
export const GET_BLOG_REQUEST = "GET_BLOG_REQUEST";
export const GET_BLOG_SUCCESS = "GET_BLOG_SUCCESS";
export const GET_BLOG_FAILURE = "GET_BLOG_FAILURE";